import { notifyBugsnag } from './bugsnag';

export type ErrorMetadata = Record<string, any>;

/**
 * Notify our error tracking system of an error
 * This is the main error reporting function that should be used throughout the application
 * It currently uses Bugsnag but can be modified to use any error tracking service
 */
export function notifyError(error: Error, metadata?: ErrorMetadata) {
    // Add any additional error processing here
    // For example, you might want to:
    // - Add common metadata
    // - Filter certain errors
    // - Transform error data
    // - Send to multiple services
    
    // Currently just forwarding to Bugsnag
    notifyBugsnag(error, metadata);
}

/**
 * Create an error with additional metadata
 * Useful for creating errors with context that will be properly tracked
 */
export function createError(message: string, metadata?: ErrorMetadata): Error {
    const error = new Error(message);
    if (metadata) {
        (error as any).metadata = metadata;
    }
    return error;
}

/**
 * Utility function to handle async errors
 * Use this to wrap async operations that might fail
 */
export async function handleAsyncError<T>(
    operation: () => Promise<T>,
    errorMessage: string,
    metadata?: ErrorMetadata
): Promise<T> {
    try {
        return await operation();
    } catch (err) {
        const error = err instanceof Error ? err : new Error(errorMessage);
        notifyError(error, metadata);
        throw error;
    }
}
